<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Eigenschaft bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.properties.update', property))">
                <form-fields :form="form" :property="property" :property-type-options="propertyTypeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'property',
            'propertyTypeOptions',
            'sortingTypeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.property.name,
                    slug: this.property.slug,
                    property_type: this.property.property_type,
                    sorting_type: this.property.sorting_type,
                    description: this.property.description,
                    filterable: this.property.filterable,
                    visible_on_product_page: this.property.visible_on_product_page,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>